export default __webpack_public_path__ + "media/images/portfolio/gallery-07-480x580-7ae44af41cdd6674b86d0164f55fae65.jpg";